<template>
    <window :title="title">
        <Material :contents-json="storyJson" :readdir="dir" :storyMode="true">
        </Material>
    </window>
</template>

<script>
import Material from "@/components/material.vue";

export default {
    components: { Material },
    name: "story",
    data() {
        return {
            title: "ストーリー編",
            dir: `story_${this.$route.params.contents}`,
        };
    },
    computed: {
        storyJson() {
            let res = require(`@/assets/story.json`);
            let json = res.find((item) => item.dir == this.dir);
            return json;
        },
    },
    mounted() {
        this.$store.commit("setLastTime", {
            contents:
                this.$route.params.contents.substring(0, 1).toUpperCase() +
                this.$route.params.contents.substring(1),
            page: "story",
        });
    },
};
</script>